import { render, staticRenderFns } from "./LawLedesCodeTypeForm.vue?vue&type=template&id=53cb2439&"
import script from "./LawLedesCodeTypeForm.vue?vue&type=script&lang=js&"
export * from "./LawLedesCodeTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./LawLedesCodeTypeForm.vue?vue&type=style&index=0&id=53cb2439&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports